// src/components/TargetDateCell.jsx
//
// A target date, and what it means today.
//
// The date on its own makes the reader do the arithmetic — "5 Sept, and today
// is the 8th, so that is three days" — once per row, down a list of forty. The
// second line does it for them, and is the reason the row is tinted.
//
// It is also what keeps the highlight readable without colour: a tint and a
// red edge say "something", the words say what. Anyone who cannot separate the
// two tints reads exactly the same information.
import React from "react";

import { formatDateOnly, targetDateLabel, targetDateState } from "../utils/common";

const TargetDateCell = ({ value, status }) => {
  const state = targetDateState(value, status);
  const note = targetDateLabel(value, status);

  if (!value) return <span className="text-muted">-</span>;

  return (
    <span className={`sk-target${state ? ` sk-target--${state === "overdue" ? "over" : "due"}` : ""}`}>
      <span className="sk-target__date">{formatDateOnly(value)}</span>
      {note && <span className="sk-target__when">{note}</span>}
    </span>
  );
};

export default TargetDateCell;
